import React, { Component } from "react";
import { connect } from "react-redux";
import xss from "xss";

import Kind from "./kind.js";
import Make from "./make.js";
import { panelActions } from "../../actions";

class KindMake extends Component {
  onChangeKind(e) {
    this.props.dispatch(panelActions.setKind(xss(e.target.value)));
  }

  onChangeMake(e) {
    this.props.dispatch(panelActions.setMake(xss(e.target.value)));
  }

  render() {
    let kinds = this.props.kinds || this.props.metalsStorage.getKinds();
    let makes = this.props.makes || this.props.metalsStorage.getMakes();
    return (
      <div className="ser-panel ser-kindmake">
        <div className="ser-kindpanel ser-iblock">
          <div id="labelkind" className="ser-filtercaption ser-iblock pb-1 pe-1">Metallart:</div>
          <div className="ser-iblock ser-kindfilter">
            {Object.keys(kinds).map(key => {
              return <Kind key={key} {...kinds[key]} />;
            })}
          </div>
          <select
            id="metallart"
            aria-labelledby="labelkind"
            className="d-md-none form-select"
            value={this.props.panelStorage.getKind()}
            onChange={this.onChangeKind.bind(this)}
          >
            {kinds.map(kind => {
              return <option
                key={"obj" + kind.name}
                value={kind.value}
              >
                {kind.name}
              </option>;
            })}
          </select>
        </div>
        <div className="ser-makepanel ser-iblock">
          <div className="ser-filtercaption ser-iblock pb-1 pe-1">Ausführung:</div>
          <div className="ser-iblock ser-makefilter">
            {Object.keys(makes).map(key => {
              return <Make key={key} {...makes[key]} />;
            })}
          </div>
          <select
            id="ausführung"
            aria-label="Ausführung"
            className="d-md-none form-select"
            value={this.props.panelStorage.getMake()}
            onChange={this.onChangeMake.bind(this)}
          >
            {makes.map(make => {
              return <option
                key={"obj" + make.name}
                value={make.value}
              >
                {make.name}
              </option>;
            })}
          </select>
        </div>
      </div>
    );
  }
}
export default connect(store => {
  return {
    metalsStorage: store.metalsStorage,
    panelStorage: store.panelStorage
  };
})(KindMake);
